"use strict";

exports.__esModule = true;
exports.default = void 0;

var _mediaUi = _interopRequireDefault(require("./mediaUi"));

var _linksUi = _interopRequireDefault(require("./linksUi"));

var _ekulturUi = _interopRequireDefault(require("./ekulturUi"));

var _uiPreview = _interopRequireDefault(require("./uiPreview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:layout": "section",
  "ui:preview": _uiPreview.default,
  "ui:options": {
    "collapsible": true,
    "hideable": true,
    "deletable": true,
    "padding": 2,
    "spacing": 2
  },
  "ui:settings": ["sectionType", "sectionLayout"],
  "ui:fieldset": ["head", "body"],
  "head": {
    "ui:fieldset": ["title", "titleHidden", "description"],
    "ui:options": {
      "grid": true,
      "spacing": 2
    },
    "title": {
      "ui:gridCols": 9,
      "ui:label": false,
      "ui:placeholder": "Tittel"
    },
    "titleHidden": {
      "ui:gridCols": 3,
      "ui:title": "Skjul tittel",
      "ui:widget": "switch"
    },
    "description": {
      "ui:gridCols": 12,
      "ui:title": "Beskrivelse",
      "ui:widget": "textarea"
    }
  },
  "body": {
    "ui:fieldset": ["media", "references", "bodytext", "links"],
    "media": _mediaUi.default,
    "references": _ekulturUi.default,
    "bodytext": {
      "ui:title": "Brødtekst",
      "ui:widget": "texteditor"
    },
    "links": _linksUi.default
  }
};
exports.default = _default;
module.exports = exports.default;